const _strings = {
  defaultColumnLabel: {
    'en-US': 'Column #{columnIndex}',
  },
  sortAscending: {
    'en-US': 'ascending',
  },
  sortDescending: {
    'en-US': 'descending',
  },
  sortButtonLabelStart: {
    'en-US': 'Sort {columnLabel}',
  },
  sortButtonLabelToggle: {
    'en-US': 'Sort {columnLabel} {direction}',
  },
  columnSortedMessage: {
    'en-US': 'Sorted {columnLabel} {direction}',
  },
  selectAllCheckboxAllLabel: {
    'en-US': 'All Rows Selected',
  },
  selectAllCheckboxSomeLabel: {
    'en-US': 'Some Rows Selected',
  },
  selectAllCheckboxNoneLabel: {
    'en-US': 'No Rows Selected',
  },
  rowSelectionColumnLabel: {
    'en-US': 'Row Selection',
  },
  rowCheckboxLabel: {
    'en-US': 'Select Row #{rowIndex}',
  },
};

export default _strings;
